// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCriteria from '../../../../shared/components/labeled-criteria';

const CreditMemoPinCriteria = props =>
    <div className='credit-memo-pin-criteria'>
        <LabeledCriteria
            className='pin-criteria'
            isRequired={false}
            label='PIN'
            maxLength='17'
            onInputChange={props.handlePinInputChange}
            placeholder='PIN'
            type='text'
            value={props.pinValue}
        />
    </div>;

CreditMemoPinCriteria.displayName = 'CreditMemoPinCriteria';
CreditMemoPinCriteria.propTypes = {
    handlePinInputChange: PropTypes.func.isRequired,
    pinValue: PropTypes.string.isRequired
};

export default CreditMemoPinCriteria;




// WEBPACK FOOTER //
// ./src/reports/credit-memo/components/credit-memo-report-criteria/pin-criteria.js